import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

export const addUser = (
  data,
  isAdmin,
  isSuperAdmin,
  isMember,
  isTaskAdmin,
  token,
) => {
  return axios.post(
    `Identity/AddUser/${false}/${isSuperAdmin}/${isMember}/${isTaskAdmin}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const updateUseCurrentUser = (
  data,
  isAdmin,
  isSuperAdmin,
  isMember,
  isTaskAdmin,
  token,
) => {
  return axios.post(
    `Identity/UpdateUser/${false}/${isSuperAdmin}/${isMember}/${isTaskAdmin}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
export const getUsersData = (
  pageNumber = 1,
  pageSize = 10,
  token,
  parentId = null,
) => {
  let url;
  if (parentId == null)
    url = `Identity/GetUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  else
    url = `Identity/GetUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&ParentId=${parentId}`;
  return axios.get(url, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteUser = (id) => {
  return axios.delete(`Identity/DeleteUser?UserId=${id}`);
};

export const rolesData = (token) => {
  return axios.get(`Identity/GetRoles`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const userRolesData = (id, token) => {
  return axios.get(`Identity/GetUserRoles?Id=${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const setRolesData = (userId, roleId, body, token) => {
  return axios.post(
    `Identity/AddUserRoleCommunities?UserId=${userId}&RoleId=${roleId}`,
    body,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const deleteUserData = (id, token) => {
  return axios.delete(`Identity/DeleteUser?UserId=${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateUserFormData = (id, token) => {
  return axios.get(`Identity/UpdateUser?UserId=${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const GetAllUserRoleCommunities = (UserId, RoleId, token) => {
  return axios.get(
    `Identity/GetUserRoleCommunities?UserId=${UserId}&RoleId=${RoleId}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
